<tran-ui-content-section
    minHeight="70vh"
    [backgroundImage]="backgroundImage()"
    [backgroundPosition]="backgroundPosition()"
    [showOverlay]="showOverlay()"
>
    <div class="flex max-w-[720px] flex-col items-start gap-4 p-4 md:p-8 lg:p-12 text-white">
        <h1 class="pb-8 text-hero-l1 break-all md:break-normal">
            <span class="font-bold">{{ eyebrow() | translate }}</span>
            <br />
            <span>{{ titleKey() | translate }}</span>
        </h1>

        <p class="text-[22px] leading-8 pb-[40px]">
            {{ description() | translate }}
        </p>

        @if (ctaLabel(); as ctaLabel) {
            <tran-primary-button
                [label]="ctaLabel"
                [href]="ctaLink() | translate"
                (clicked)="ctaClicked.emit()"
            />
        }
    </div>
</tran-ui-content-section>
